import { render, staticRenderFns } from "./Datatables.vue?vue&type=template&id=0201b464&scoped=true&"
import script from "./Datatables.vue?vue&type=script&lang=js&"
export * from "./Datatables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0201b464",
  null
  
)

export default component.exports